// Read and write the whole view in the query string, so a view can be sent to
// someone. Without this the tool can only ever be shared as a screenshot, which
// strips the filters and weighting that produced it.

const LIST_KEYS = ['gender', 'ageGroup', 'educationLevel', 'income', 'employmentStatus', 'urbanicity'];
const SELECTION_LIST_KEYS = ['country', 'incomeLevel'];
const WEIGHT_KEYS = ['individual', 'household', 'community', 'society'];

const idsToParam = (values) => values.map((value) => value.id).join('.');

const paramToIds = (raw, toOption) =>
	!raw ? [] : raw.split('.').filter(Boolean).map(toOption).filter(Boolean);

export const readUrlState = () => {
	const params = new URLSearchParams(window.location.search);
	const state = {};

	const year = Number(params.get('year'));
	if (year) state.year = year;

	const compare = params.get('compare');
	if (compare) state.comparisonYear = compare === 'none' ? 'None' : Number(compare);

	LIST_KEYS.forEach((key) => {
		const raw = params.get(key);
		if (raw !== null) state[key] = raw;
	});

	SELECTION_LIST_KEYS.forEach((key) => {
		const raw = params.get(key);
		if (raw !== null) state[key] = raw;
	});

	const weights = params.get('weights');
	if (weights) {
		const parts = weights.split('.').map(Number);
		if (parts.length === 4 && parts.every((part) => Number.isFinite(part))) {
			state.weights = Object.fromEntries(WEIGHT_KEYS.map((key, i) => [key, parts[i]]));
		}
	}

	if (params.get('colorBy')) state.colorBy = params.get('colorBy');
	if (params.get('safe') === '1') state.colourBlindSafe = true;

	return state;
};

export const writeUrlState = ({ year, comparisonYear, filters, selection, weights, colourBlindSafe }) => {
	const params = new URLSearchParams();

	params.set('year', String(year));
	params.set('compare', comparisonYear === 'None' ? 'none' : String(comparisonYear));

	LIST_KEYS.forEach((key) => {
		const values = filters[key];
		if (values?.length) params.set(key, idsToParam(values));
	});

	SELECTION_LIST_KEYS.forEach((key) => {
		const values = selection[key];
		if (values?.length) params.set(key, idsToParam(values));
	});

	if (WEIGHT_KEYS.some((key) => weights[key] !== 50)) {
		params.set('weights', WEIGHT_KEYS.map((key) => weights[key]).join('.'));
	}

	if (selection.colorBy) params.set('colorBy', selection.colorBy);
	if (colourBlindSafe) params.set('safe', '1');

	const next = `${window.location.pathname}?${params.toString()}`;
	window.history.replaceState(null, '', next);
};

export { paramToIds, LIST_KEYS, SELECTION_LIST_KEYS, WEIGHT_KEYS };
